import {Component, Input, EventEmitter, Output} from '@angular/core'

@Component({
  selector: 'dmmp-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

  @Input() identifier
  @Input() data
  @Output() anchorCustom = new EventEmitter()

  ancla(event, data) {
    if (data.indexOf('#') === 0 && data?.length > 1) {
      this.anchorCustom.emit({event: event, id: data})
    }
  }
}
